// PWA: service worker registration + install prompt
(function () {
  if (!('serviceWorker' in navigator)) return;

  // Inline SW via blob so it runs on the store origin (not cdn.shopify.com)
  const swSource = `
    self.addEventListener('install', () => self.skipWaiting());
    self.addEventListener('activate', e => e.waitUntil(clients.claim()));
    self.addEventListener('fetch', e => {
      if (e.request.method !== 'GET') return;
      e.respondWith(fetch(e.request).catch(() => caches.match(e.request)));
    });
  `;
  const blob = new Blob([swSource], { type: 'application/javascript' });
  const swUrl = URL.createObjectURL(blob);
  navigator.serviceWorker.register(swUrl, { scope: '/' }).catch(function () {});

  // --- Install prompt banner (gentle, non-intrusive) ---
  let deferredPrompt = null;
  var DISMISSED_KEY = 'lb_pwa_dismissed';
  var DISMISS_DAYS = 7;
  var SHOW_DELAY_MS = 30000;

  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  function wasDismissedRecently() {
    var ts = localStorage.getItem(DISMISSED_KEY);
    if (!ts) return false;
    return (Date.now() - parseInt(ts, 10)) < DISMISS_DAYS * 86400000;
  }

  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    deferredPrompt = e;
    if (isProductPage() || wasDismissedRecently()) return;
    setTimeout(function () {
      if (deferredPrompt) showBanner();
    }, SHOW_DELAY_MS);
  });

  function showBanner() {
    if (document.getElementById('pwa-install-banner')) return;

    var banner = document.createElement('div');
    banner.id = 'pwa-install-banner';
    banner.setAttribute('role', 'banner');
    banner.innerHTML =
      '<span class="pwa-banner__text">Add Leon Baker to your home screen</span>' +
      '<button class="pwa-banner__install" aria-label="Install app">Install</button>' +
      '<button class="pwa-banner__close" aria-label="Dismiss">&#x2715;</button>';

    Object.assign(banner.style, {
      position: 'fixed',
      bottom: '16px',
      left: '50%',
      transform: 'translateX(-50%) translateY(100px)',
      zIndex: '9999',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '10px 16px',
      background: '#5c0a13',
      color: '#fff',
      fontFamily: 'inherit',
      fontSize: '13px',
      borderRadius: '8px',
      boxShadow: '0 4px 16px rgba(0,0,0,.18)',
      maxWidth: '360px',
      width: 'calc(100% - 32px)',
      opacity: '0',
      transition: 'transform .4s ease, opacity .4s ease',
    });

    var installBtn = banner.querySelector('.pwa-banner__install');
    Object.assign(installBtn.style, {
      flexShrink: '0',
      padding: '6px 14px',
      background: '#fff',
      color: '#5c0a13',
      border: 'none',
      borderRadius: '4px',
      fontWeight: '600',
      cursor: 'pointer',
      fontSize: '12px',
    });

    var closeBtn = banner.querySelector('.pwa-banner__close');
    Object.assign(closeBtn.style, {
      flexShrink: '0',
      background: 'none',
      border: 'none',
      color: 'rgba(255,255,255,.7)',
      fontSize: '16px',
      cursor: 'pointer',
      lineHeight: '1',
      padding: '4px',
    });

    function dismiss() {
      banner.style.opacity = '0';
      banner.style.transform = 'translateX(-50%) translateY(100px)';
      setTimeout(function () { banner.remove(); }, 400);
      localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    }

    installBtn.addEventListener('click', function () {
      banner.remove();
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function () { deferredPrompt = null; });
    });

    closeBtn.addEventListener('click', dismiss);

    document.body.appendChild(banner);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.style.opacity = '1';
        banner.style.transform = 'translateX(-50%) translateY(0)';
      });
    });
  }

  window.addEventListener('appinstalled', function () {
    const banner = document.getElementById('pwa-install-banner');
    if (banner) banner.remove();
    deferredPrompt = null;
  });
})();
